/**
 * 语音上下文（T10）。
 *
 * 拆成独立文件（非组件导出）以避免 react-refresh 的 only-export-components 告警。
 */

import { createContext, useContext } from 'react';

import type { VoiceController, VoiceSnapshot } from './controller';

export interface VoiceContextValue {
  controller: VoiceController;
  snapshot: VoiceSnapshot;
}

export const VoiceContext = createContext<VoiceContextValue | null>(null);

/** 读取语音上下文；不在 Provider 内直接抛错（编程错误，早失败）。 */
export function useVoice(): VoiceContextValue {
  const value = useContext(VoiceContext);
  if (value === null) throw new Error('useVoice 必须在 <VoiceProvider> 内使用');
  return value;
}

/** 允许缺失上下文的读取（组件可静默降级）。 */
export function useOptionalVoice(): VoiceContextValue | null {
  return useContext(VoiceContext);
}